import { createBaseAction } from '@essent/common';

export const enum SelectedSupplyAddressTypes {
  SELECT_ID = '[SelectedSupplyAddressTypes] Select Id',
  CLEAR = '[SelectedSupplyAddressTypes] Clear',
}

export const selectSupplyAddressId = createBaseAction<string | undefined>(
  SelectedSupplyAddressTypes.SELECT_ID
);

export const clearSelectedSupplyAddressId = createBaseAction(
  SelectedSupplyAddressTypes.CLEAR
);
